export const timeZones: { [key: string]: string } = {
  'b8762ebf-728e-e711-80f8-005056975fe0': 'America/Los_Angeles',
  '8e229164-4c97-de11-8de3-0019d18a6560': 'America/Chicago',
  '90e37b27-4d95-ee11-82cf-0022482fd8ca': 'America/Chicago',
  '1aea3a42-05be-ed11-828b-005056975140': 'America/Denver',
  'b8ba3f46-6b81-ed11-827e-005056975140': 'America/New_York',
  'de21be7f-0b58-ea11-81b1-005056975fe0': 'America/Chicago',
  '8d229164-4c97-de11-8de3-0019d18a6560': 'America/New_York',
  '4560af42-b42b-ee11-82ad-005056975140': 'America/New_York',
  'ffe59a9e-da31-e811-8122-005056975fe0': 'America/Chicago',
  '8c229164-4c97-de11-8de3-0019d18a6560': 'America/Chicago',
  'd0729841-c0d4-e911-8193-005056975fe0': 'America/Chicago',
  'b023f072-728e-e711-80f8-005056975fe0': 'America/Los_Angeles',
};
